<template>
    <app-ghost-mode>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4 col-sm-6 col-12 offset-md-4 offset-sm-3 offset-0 my-5">
                    <div class="auth-box p-5">
                        <form>
                            <h3 class="text-center">Items Location <i class="fas fa-map-marker-alt fa-sm text-dark-green"></i></h3>
                            <!-- Alert Messages -->
                            <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n2 mt-3 p-1`" role="alert">
                                <i class="fas fa-exclamation-circle"></i> {{ msg }}
                            </div>
                            <div class="mt-3">
                                <p class="text-center">
                                    Real quick, your buyers will like to know the location where this and future 
                                    items will be shipped from or picked up. Enter your location to proceed
                                </p>
                                <input v-model="address" type="text" ref="address" class="form-control no-lines text-center" 
                                    placeholder="Ex: 123 Street, City, State, Country">
                            </div>
                            <div class="text-center mt-4">
                                <button @click.prevent="updateMyLocation" class="loadn btn btn-dark-green form-control">Save Location</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "ValidateAddress",
    data() {
        return {
            msg: '',
            color: 'danger',
            address: '',
        }
    },
    components: {
        appGhostMode: GhostMode
    },
    methods: {
        ...mapActions(['updateUsersCity', 'updateUsersCountry']),
        assignValues() {
            if(this.user.address){ this.address = this.user.address }
        },
        updateMyLocation(){
            this.color = "danger"
            if(this.address === ''){ this.msg = "Your address is required!"; return }
            if(this.address.length < 4){ this.msg = "Your full address is required!"; return }
            let userObj = {
                userId: this.user._id,
                city: this.address.toLowerCase()
            }
            this.updateUsersCity(userObj)
            .then(() => {
                this.color = "success"
                this.msg = "Your approx. location was updated successfully!"
                this.address = ""
            }).catch((e) => {
                this.msg = "Updating your approx. location failed, try again."
            })
        },
        updateMyCountry(){
            let userObj = {
                userId: this.user._id,
                alphaCode: this.user.alphaCode
            }
            this.updateUsersCountry(userObj).then(() => {}).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user']),
    },
    mounted() {
        if(this.user && !this.user.countryConfirmed){
            this.updateMyCountry()
        }
        this.$refs.address.focus()
    },
    created() {
        this.assignValues()
    }
}
</script>